import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './index.less';

const Navigation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState('home');

  // 根据当前路径设置活动标签
  useEffect(() => {
    const path = location.pathname;
    if (path === '/') {
      setActiveTab('home');
    } else if (path === '/about') {
      setActiveTab('about');
    } else if (path.startsWith('/core-technology')) {
      setActiveTab('core-tech');
    } else if (path.startsWith('/solution')) {
      setActiveTab('solution');
    } else if (path === '/contact') {
      setActiveTab('contact');
    }
  }, [location.pathname]);

  const navigationItems = [
    { id: 'home', label: 'Home', path: '/' },
    { 
      id: 'about', 
      label: 'About Us', 
      path: '/about',
      hasDropdown: true,
      dropdownItems: [
        { id: 'choose-us', label: 'Choose Us', path: '/choose-us' },
        { id: 'partners', label: 'Partners', path: '/partners' }
      ]
    },
    {
      id: 'core-tech',
      label: 'Core Technology',
      hasDropdown: true,
      dropdownItems: [
        { id: 'high-speed', label: 'High Speed & High Precision', path: '/high-speed-high-precision' },
        { id: 'machine-vision', label: 'Advanced Machine Vision', path: '/advanced-machine-vision' },
        { id: 'system-integration', label: 'System Integration', path: '/system-integration' },
        { id: 'intelligent-software', label: 'Intelligent Software', path: '/intelligent-software' }
      ]
    },
    {
      id: 'solution',
      label: 'Solution',
      hasDropdown: true,
      dropdownItems: [
        { id: '3c', label: '3C', path: '/3c' },
        { id: 'medical', label: 'Medical Products', path: '/medical-products' },
        { id: 'ceramic', label: 'Ceramic components', path: '/ceramic-components' },
        { id: 'semiconductor', label: 'Semiconductor', path: '/semiconductor' }
      ]
    },
    { id: 'contact', label: 'Contact Us', path: '/contact' }
  ];

  const handleTabClick = (item) => {
    if (item.path) {
      window.scrollTo(0, 0);
      setActiveTab(item.id);
      navigate(item.path);
    }
  };

  const handleLogoClick = () => {
    setActiveTab('home');
    navigate('/');
  };

  // 渲染原生下拉菜单项
  const renderDropdownItems = (dropdownItems) => {
    return dropdownItems.map((item) => (
      <div
        key={item.id}
        className="dropdown-item"
        onClick={() => handleTabClick(item)}
      >
        {item.label}
      </div>
    ));
  };

  return (
    <div className="navigation-container">
      <div className="background-bar"></div>
      <div className="navigation-bar">
        <div
          className="logo-section"
          onClick={handleLogoClick}
        >
          <img src="/images/home/u100.png" alt="Logo" className="logo" />
        </div>
        <div className="tab-section">
          {navigationItems.map((item) => {
            if (item.hasDropdown) {
              return (
                <div key={item.id} className="dropdown-wrapper">
                  <div
                    className={`nav-tab ${activeTab === item.id ? 'active' : ''}`}
                    onClick={() => handleTabClick(item)}
                  >
                    <span className="tab-text">{item.label}</span>
                  </div>
                  <div className="native-dropdown-menu">
                    {renderDropdownItems(item.dropdownItems)}
                  </div>
                </div>
              );
            }

            return (
              <div
                key={item.id}
                className={`nav-tab ${activeTab === item.id ? 'active' : ''}`}
                onClick={() => handleTabClick(item)}
              >
                <span className="tab-text">{item.label}</span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Navigation;